import React, { useState } from "react";
import "../styles/armsform.css";

const Arms = () => {
    const [formData, setFormData] = useState({
        token_id: "E Arms - ",
        license_no: "",
        local_no: "",
        date: "",
        name: "",
        father_name: "",
        cnic: "",
        address: "",
        profession: "",
        weapon: "",
        no: "",
        bore: "",
        cartridge_s: "",
        cartridge_a: "",
        validity: "",
        expiry: "",
        reason: "",
        status: "",
        phone_no: "",
    });

    const [message, setMessage] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (isSubmitting) return;
        
        // Validate required fields
        const requiredFields = ['token_id', 'license_no', 'local_no', 'date', 'name', 
                               'father_name', 'cnic', 'address', 'weapon', 
                               'no', 'bore', 'validity', 'expiry', 'status'];
        
        const missingFields = requiredFields.filter(field => !formData[field]);
        
        if (missingFields.length > 0) {
            setMessage(`Please fill in required fields: ${missingFields.join(', ')}`);
            setTimeout(() => setMessage(null), 3000);
            return;
        }

        setIsSubmitting(true);
        setMessage(null);

        try {
            const response = await fetch("https://chaman.gob.pk/eac_backend/arms.php", {
                method: "POST",
                headers: { 
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ 
                    action: "add", 
                    ...formData,
                    s_count: "save"
                }),
            });

            const result = await response.json();
            console.log("Server response:", result);
            
            if (result.status === "success") {
                setMessage("Record saved successfully!");
                setShowPopup(true);
                
                // Reset form
                setFormData({
                    token_id: "E Arms - ",
                    license_no: "",
                    local_no: "",
                    date: "",
                    name: "",
                    father_name: "",
                    cnic: "",
                    address: "",
                    profession: "",
                    weapon: "",
                    no: "",
                    bore: "",
                    cartridge_s: "",
                    cartridge_a: "",
                    validity: "",
                    expiry: "",
                    reason: "",
                    status: "",
                    phone_no: "",
                });
                
                setTimeout(() => setShowPopup(false), 2000);
                setTimeout(() => setMessage(null), 3000);
            } else {
                setMessage("Error: " + (result.message || "Unknown error"));
                setTimeout(() => setMessage(null), 3000);
            }
        } catch (error) {
            console.error("Error details:", error);
            setMessage("An error occurred: " + error.message);
            setTimeout(() => setMessage(null), 5000);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="lc-form-container">
            {message && (
                <div className={message.includes("success") ? "lc-success-message" : "lc-error-message"} style={{
                    padding: "10px",
                    margin: "10px",
                    borderRadius: "5px",
                    backgroundColor: message.includes("success") ? "#d4edda" : "#f8d7da",
                    color: message.includes("success") ? "#155724" : "#721c24",
                    border: message.includes("success") ? "1px solid #c3e6cb" : "1px solid #f5c6cb"
                }}>
                    {message}
                </div>
            )}
            
            <form className="lc-form" onSubmit={handleSubmit}>
                <div className="lc-left-section">
                    <div className="lc-form-group">
                        <label className="lc-label">Token ID:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="token_id"
                                value={formData.token_id}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    
                    <div className="lc-form-group">
                        <label className="lc-label">Name:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    
                    <div className="lc-form-group">
                        <label className="lc-label">S/O:</label>
                        <div className="lc-input-container">
                            <input
                                name="father_name"
                                value={formData.father_name}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    
                    <div className="lc-form-group">
                        <label className="lc-label">CNIC:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="cnic"
                                value={formData.cnic}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    
                    <div className="lc-form-group">
                        <label className="lc-label">Phone No:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="phone_no"
                                value={formData.phone_no}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    
                    <div className="lc-form-group">
                        <label className="lc-label">R/O:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    
                    <div className="lc-form-group">
                        <label className="lc-label">Profession:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="profession"
                                value={formData.profession}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    
                    <div className="lc-form-group">
                        <label className="lc-label">Weapon:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="weapon"
                                value={formData.weapon}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    
                    <div className="lc-form-group">
                        <label className="lc-label">No:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="no"
                                value={formData.no}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                </div>

                <div className="lc-right-section">
                    <div className="lc-form-group">
                        <label className="lc-label">Bore:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="bore"
                                value={formData.bore}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    
                    <div className="lc-form-group">
                        <label className="lc-label">Cartridge at a time:</label>
                        <div className="lc-input-container">
                            <input
                                type="number"
                                name="cartridge_s"
                                value={formData.cartridge_s}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    
                    <div className="lc-form-group">
                        <label className="lc-label">Cartridge Annually:</label>
                        <div className="lc-input-container">
                            <input
                                type="number"
                                name="cartridge_a"
                                value={formData.cartridge_a}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    
                    <div className="lc-form-group">
                        <label className="lc-label">Validity:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="validity"
                                value={formData.validity}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    
                    <div className="lc-form-group">
                        <label className="lc-label">Expiry:</label>
                        <div className="lc-input-container">
                            <input
                                type="date"
                                name="expiry"
                                value={formData.expiry}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    
                    <div className="lc-form-group">
                        <label className="lc-label">License No:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="license_no"
                                value={formData.license_no}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    
                    <div className="lc-form-group">
                        <label className="lc-label">Letter No:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="local_no"
                                value={formData.local_no}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    
                    <div className="lc-form-group">
                        <label className="lc-label">Date:</label>
                        <div className="lc-input-container">
                            <input
                                type="date"
                                name="date"
                                value={formData.date}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    
                    <div className="lc-form-group">
                        <label className="lc-label">Reason:</label>
                        <div className="lc-input-container">
                            <textarea
                                name="reason"
                                value={formData.reason}
                                onChange={handleChange}
                                className="lc-input"
                                rows="3"
                            />
                        </div>
                    </div>
                    
                    <div className="lc-form-group">
                        <label className="lc-label">Status:</label>
                        <div className="lc-input-container">
                            <select
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                                className="lc-select"
                                required
                            >
                                <option value="" disabled>Select Status</option>
                                <option value="Recieved">Recieved</option>
                                <option value="Ready">Ready</option>
                            </select>
                        </div>
                    </div>
                </div>
                
                <button type="submit" className="lc-submit-btn" disabled={isSubmitting}>
                    {isSubmitting ? "Saving..." : "Save"}
                </button>
            </form>

            {showPopup && (
                <div className="lc-popup">
                    Data saved successfully!
                </div>
            )}
        </div>
    );
};

export default Arms;